export const itemType = 'NEXT_VIDEO';
export const itemTypePlaylist = 'PLAYLIST';

export const itemSources = {
    nextVideos: 'NEXT_VIDEOS',
    searchVideos: 'SEARCH_VIDEOS',
    relatedVideos: 'RELATED_VIDEOS',
};
